<template>
    <div style="margin-bottom:50px">
        <div class="tit-head">
            <div>填空题</div>
            <!-- <div class="stem" v-html="info.title" id="content"></div> -->
            <mavonEditor 
                :boxShadow="false" 
                styleEditor="min-height: 20px;width: auto;" 
                :content="info.title" 
                :subfield="false" 
                :toolbarsFlag="false" 
                previewBackground="#fff"
                defaultOpen="preview" 
            />
        </div>
        <div v-if="info.yourAnswer && info.yourAnswer.length">
            <div v-for="(item,i) in info.yourAnswer" :key="i" class="result">
                <span>第{{i+1}}个位置：</span>
                <Input :value="item" @on-change="changeInput" @on-focus="focus(i)" />
            </div>
        </div>
        <div v-else>
        <div v-for="(item,i) in answerCount" :key="i" class="result">
            <span>第{{i+1}}个位置：</span>
            <Input :model="item" @on-change="changeInput" @on-focus="focus(i)" />
        </div>
        </div>
    </div>
</template>
<script>
import mavonEditor from './mavonEditor.vue'
export default {
    components:{ mavonEditor },
    props:{
        info:{
            type:Object,
            default:null
        },
        correctAnswer:{
            type:String,
            default:null
        },
        answerCount:{
            type:Number,
            default:null
        }
    },
    data(){
        return{
        }
    },
    mounted(){
    },
    methods:{
        focus(i){
            this.currIndex = i 
        },
        changeInput(event){
            if(!this.info.yourAnswer){
                this.info.yourAnswer = []
            }
            this.info.yourAnswer[this.currIndex] = event.target.value
            this.$emit('childQuestionFn', {answer:this.info.yourAnswer, anserCount:this.answerCount, questionId: this.info.id});
        },
    }
}
</script>
<style lang="less" scoped>
.right-key{
    background-color: #eee;
    padding: 20px;
    display: inline-flex;
    justify-content: space-between;
    width: 100%;
    border-radius: 6px;
    span:nth-child(2){
        cursor: pointer;
    }
}
.result{
    margin-left: 60px;
    display: flex;
    height: 50px;
    line-height: 40px;
    /deep/ .ivu-input-wrapper{
        width: 50%;
        margin-left: 10px;
        outline: none;
    }
    /deep/ .ivu-input{
        width: 50%;
        outline: none;
        border: none;
        border-bottom: 1px solid #555;
        padding: 0 10px;
        border-radius: 0;
    }
    /deep/ .ivu-input:focus{
        outline:none;
        box-shadow: 0 0 0 2px transparent; 
    }
}
.tit-head{
    display: inline-flex;
    flex-wrap: wrap;
    width: 100%;
    div:first-child{
        display: inline-flex;
        align-items: center;
        color: #555;
        height: 26px;
        line-height: 26px;
        background-color: #18A0FB;
        color: #fff;
        padding: 0 10px;
        border-radius: 13px 13px 0 13px;
        margin-right: 15px;
        min-width: 62px;
    }
    .stem{
        width: 80%;
        /deep/ img{
            max-width: 100%;
        }
        /deep/ p{
            font-size: 16px;
            font-weight: 700;
            color: #555;
        }
    }
}

</style>


// WEBPACK FOOTER //
// src/views/practise/components/questionFillBlank.vue